import {
  GET_SALESFORCE_DESCRIBE_REQUEST,
  GET_SALESFORCE_DESCRIBE_SUCCESS,
  GET_SALESFORCE_DESCRIBE_FAILURE,
  GET_SALESFORCE_PREVIEW_REQUEST,
  GET_SALESFORCE_PREVIEW_SUCCESS,
  GET_SALESFORCE_PREVIEW_FAILURE,
  GET_SALESFORCE_IMPORT_MAPPINGS_REQUEST,
  GET_SALESFORCE_IMPORT_MAPPINGS_SUCCESS,
  GET_SALESFORCE_IMPORT_MAPPINGS_FAILURE,
  GET_SALESFORCE_LISTVIEWS_REQUEST,
  GET_SALESFORCE_LISTVIEWS_SUCCESS,
  GET_SALESFORCE_LISTVIEWS_FAILURE,
  LOG_OUT_SUCCESS,
} from "../../constants/ActionTypes";
import * as errMessages from "../../constants/ErrorMessages";
// import * as messages from "../../constants/Messages";
import { formatErrorMessage } from "../../utils/utils";
import { HTTP_400_BAD_REQUEST_CODE } from "../../constants/HttpStatusCode";

const initialState = {
  sobject_name: 0,
  curr_sobject_name: 0,
  listview_id: "",
  fields: {},
  preview: [],
  listviews: [],
  mapping: {},
  errorMessage: "",
  shortMessage: "",
  successMessage: "",
  isLoadingPreview: false,
  isLoadingFields: false,
  isLoadingListviews: false,
  isLoadingMapping: false,
  loadingPreviewFailed: false,
  expiredAccessError: false,
};

const isExpiredAccessError = (error) => {
  return (
    error &&
    error.status === HTTP_400_BAD_REQUEST_CODE &&
    typeof error.data.message === "object" &&
    error.data.message["error"] === "invalid_grant"
  );
};

export default (state = initialState, action) => {
  state = {
    ...state,
    shortMessage: "",
    successMessage: "",
    errorMessage: "",
    loadingPreviewFailed: false,
  };

  let fields;

  switch (action.type) {
    case GET_SALESFORCE_DESCRIBE_REQUEST:
      return {
        ...state,
        isLoadingFields: true,
        expiredAccessError: false,
        curr_sobject_name: action.payload.sobject_name,
      };
    case GET_SALESFORCE_DESCRIBE_SUCCESS:
      if (state.curr_sobject_name === action.payload.sobject_name) {
        fields = {};
        Object.values(action.payload.fields.fields).forEach(
          (item) => (fields[item.name] = item)
        );
        return {
          ...state,
          expiredAccessError: false,
          isLoadingFields: false,
          fields: fields,
        };
      } else {
        return state;
      }
    case GET_SALESFORCE_DESCRIBE_FAILURE:
      return {
        ...state,
        isLoadingFields: false,
        expiredAccessError: isExpiredAccessError(action.payload.error),
        errorMessage: isExpiredAccessError(action.payload.error)
          ? action.payload.error.data.message
          : formatErrorMessage(
            action.payload.error,
            errMessages.ERR_GET_SALESFORCE_DESCRIBE_FAILURE
          ),
      };
    case GET_SALESFORCE_PREVIEW_REQUEST:
      return {
        ...state,
        isLoadingPreview: true,
        expiredAccessError: false,
      };
    case GET_SALESFORCE_PREVIEW_SUCCESS:
      return {
        ...state,
        preview: action.payload.data,
        isLoadingPreview: false,
        expiredAccessError: false,
      };
    case GET_SALESFORCE_PREVIEW_FAILURE:
      return {
        ...state,
        isLoadingPreview: false,
        loadingPreviewFailed: true,
        expiredAccessError: isExpiredAccessError(action.payload.error),
        errorMessage: isExpiredAccessError(action.payload.error)
          ? action.payload.error.data.message
          : formatErrorMessage(
            action.payload.error,
            errMessages.ERR_GET_SALESFORCE_PREVIEW_FAILURE
          ),
      };
    case GET_SALESFORCE_IMPORT_MAPPINGS_REQUEST:
      return {
        ...state,
        isLoadingMapping: true,
        expiredAccessError: false,
      };
    case GET_SALESFORCE_IMPORT_MAPPINGS_SUCCESS:
      fields = {};
      Object.values(action.payload.fields.fields).forEach(
        (item) => (fields[item.name] = item)
      );
      return {
        ...state,
        isLoadingMapping: false,
        sobject_name: action.payload.sobject_name,
        listview_id: action.payload.listview_id,
        listviews: action.payload.listviews.filter(
          (item) => item.soqlCompatible
        ),
        mapping: action.payload.mapping,
        fields: fields,
        preview: action.payload.preview,
        expiredAccessError: false,
      };
    case GET_SALESFORCE_IMPORT_MAPPINGS_FAILURE:
      return {
        ...state,
        isLoadingMapping: false,
        mapping: initialState.mapping,
        expiredAccessError: isExpiredAccessError(action.payload.error),
      };
    case GET_SALESFORCE_LISTVIEWS_REQUEST:
      return {
        ...state,
        isLoadingListviews: true,
        listviews: [],
        curr_sobject_name: action.payload.sobject_name,
      };
    case GET_SALESFORCE_LISTVIEWS_SUCCESS:
      if (state.curr_sobject_name === action.payload.sobject_name) {
        return {
          ...state,
          isLoadingListviews: false,
          listviews: action.payload.listviews.filter(
            (item) => item.soqlCompatible
          ),
        };
      } else {
        return state;
      }
    case GET_SALESFORCE_LISTVIEWS_FAILURE:
      return {
        ...state,
        isLoadingListviews: false,
        expiredAccessError: isExpiredAccessError(action.payload.error),
        errorMessage: isExpiredAccessError(action.payload.error)
          ? action.payload.error.data.message
          : formatErrorMessage(
            action.payload.error,
            errMessages.ERR_GET_SALESFORCE_LISTVIEWS_FAILURE
          ),
      };

    case LOG_OUT_SUCCESS:
      return initialState;
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/redux/reducers/salesforceAddressSetting.js